import { selectOpportunityActionRequired } from '@/model/selectors';
import { Zap } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAdvisorNavigation } from './AdvisorDashboardRouteGuard';
import { AdvisorUserMenu } from './AdvisorUserMenu';
import { CustomTooltip } from './CustomTooltip';
import { AvatarNotificationBubble } from './NotificationBubble';
import { Avatar } from './ui/avatar';

type AdvisorDashboardTopBarProps = {
  advisorSideBarMobileButton: React.ReactNode;
  handleClickSignOut: () => void;
};

export function AdvisorDashboardTopBar({
  advisorSideBarMobileButton,
  handleClickSignOut,
}: AdvisorDashboardTopBarProps) {
  const location = useLocation();
  const { navigateToOpportunitiesDashboard } = useAdvisorNavigation();
  const opportunityActionRequired = useSelector(selectOpportunityActionRequired);
  const handleOpportunitiesClick = () => {
    if (!location.pathname.endsWith('/opportunities')) {
      navigateToOpportunitiesDashboard();
    }
  };

  return (
    <div className="top-0 z-50 flex shrink-0 items-center gap-x-4 border-b border-gray-200 bg-[#f3eefd] px-4 py-1 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      {advisorSideBarMobileButton}
      <div className="flex h-14 w-full flex-row-reverse items-center gap-3">
        <AdvisorUserMenu handleClickSignOut={handleClickSignOut} />
        <CustomTooltip content="Opportunities">
          <div
            className="relative cursor-pointer"
            onClick={handleOpportunitiesClick}
            role="button"
            tabIndex={0}
            id="topbar-opportunities"
            data-testid="topbar-opportunities"
          >
            <Avatar className="border-primary-300 h-8 w-8 items-center justify-center border bg-white">
              <Zap
                className="text-primary"
                strokeWidth={1}
              />
            </Avatar>
            {opportunityActionRequired && <AvatarNotificationBubble />}
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
}
